import React, { useEffect, useState } from 'react';
import '../styles/WalletModal.css';
import { useNavigate } from 'react-router-dom';
import { 
  FaWallet, 
  FaCopy, 
  FaCheckCircle, 
  FaUser,
  FaHistory,
  FaTimes,
  FaChevronRight,
  FaCoins
} from 'react-icons/fa';
import kleverImage from '../assets/klever.png';

const WalletModal = ({ isOpen, onClose, walletAddress }) => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && walletAddress) {
      setLoading(true);
      const url = `https://api.mainnet.klever.org/v1.0/address/${walletAddress}`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const fetchedBalance = data.data.account.balance / 1000000;
          setBalance(fetchedBalance);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching balance:', error);
          setBalance(0);
          setLoading(false);
        });
    }
  }, [isOpen, walletAddress]);

  const copyAddress = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(walletAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleAccountClick = () => {
    navigate('/wallet');
    onClose();
  };

  const handleTransactionHistoryClick = () => {
    navigate('/wallet/history/listings');
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const formatBalance = (bal) => {
    if (bal === null) return '...';
    return bal.toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  };

  if (!isOpen) return null;

  return (
    <div className="wallet-modal-overlay" onClick={handleOverlayClick}>
      <div className="wallet-modal-container">
        {/* Header */}
        <div className="wallet-modal-header">
          <div className="wallet-header-content">
            <FaWallet className="wallet-header-icon" />
            <h2 className="wallet-header-title">My Wallet</h2>
          </div>
          <button className="wallet-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Balance Section */}
        <div className="wallet-balance-section">
          <div className="balance-card">
            <div className="balance-label">
              <FaCoins className="balance-label-icon" />
              <span>Total Balance</span>
            </div>
            <div className="balance-display">
              {loading ? (
                <div className="balance-loading">
                  <div className="balance-spinner"></div>
                </div>
              ) : (
                <>
                  <img src={kleverImage} alt="KLV" className="balance-token-icon" />
                  <span className="balance-amount">{formatBalance(balance)}</span>
                  <span className="balance-currency">KLV</span>
                </>
              )}
            </div>
          </div>

          {/* Address Section */}
          <div className="wallet-address-card">
            <span className="address-label">Wallet Address</span>
            <div className="address-display" onClick={copyAddress}>
              <span className="address-text">
                {`${walletAddress.slice(0, 8)}...${walletAddress.slice(-6)}`}
              </span>
              <button className="address-copy-btn">
                {copied ? <FaCheckCircle className="copy-success" /> : <FaCopy />}
              </button>
            </div>
            {copied && <span className="copy-feedback">Copied!</span>}
          </div>
        </div>

        {/* Menu Items */}
        <div className="wallet-menu-section">
          <button className="wallet-menu-item" onClick={handleAccountClick}>
            <div className="menu-item-left">
              <div className="menu-item-icon">
                <FaUser />
              </div>
              <span className="menu-item-text">Account Details</span>
            </div>
            <FaChevronRight className="menu-item-arrow" />
          </button>

          <button className="wallet-menu-item" onClick={handleTransactionHistoryClick}>
            <div className="menu-item-left">
              <div className="menu-item-icon">
                <FaHistory />
              </div>
              <span className="menu-item-text">Transaction History</span>
            </div>
            <FaChevronRight className="menu-item-arrow" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;